import Swal from "sweetalert2";
import "./index.css";
import { Path } from "../../../Api/Path";

export const ShowCustomErrorModal = async ({
  message,
  title = "Lỗi đăng ký",
}) => {
  const formattedMessage = message.replace(/\n/g, "<br>");
  const result_1 = await Swal.fire({
    html: `
        <div class="custom-icon-container notranslate">
          <div class="info-icon notranslate">
            <i class="info-i notranslate">i</i>
          </div>
        </div>
        <h2 class="custom-title notranslate">${title}</h2>
        <div class="custom-message notranslate">${formattedMessage}</div>
      `,
    showConfirmButton: true,
    confirmButtonText: "Đóng",
    showCancelButton: true,
    cancelButtonText: "Liên hệ",
    customClass: {
      popup: "custom-modal notranslate",
      confirmButton: "custom-confirm-button notranslate",
      cancelButton: "custom-contact-button notranslate",
      htmlContainer: "custom-html-container notranslate",
    },
    buttonsStyling: false,
    showClass: {
      popup: "animate__animated animate__fadeIn",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOut",
    },
  });
  if (result_1.isDismissed && result_1.dismiss === Swal.DismissReason.cancel) {
    window.open(Path.SUPPORT, "_blank");
  }
};
